import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const InputStyled = styled.input`
    position: relative;
    top: ${convertPxToRem(2)};
    margin-right: ${convertPxToRem(5)};

    &:disabled {
        cursor: not-allowed;
    }
`;

// component
export const EuoCheckbox = ({ onEuoChange, euoIsChecked }) => {
    const { selectedBatchObj } = useQueueContext();
    return (
        <div>
            <InputStyled
                type="checkbox"
                onChange={onEuoChange}
                checked={euoIsChecked}
                disabled={!selectedBatchObj?.isEditable?.uploadTitle}
            />
            <b>Editorial use only</b>
        </div>
    );
};

export default EuoCheckbox;

// prop-types
EuoCheckbox.propTypes = {
    onEuoChange: PropTypes.func.isRequired,
    euoIsChecked: PropTypes.bool.isRequired
};
